import {getNotifications} from "@/api/notification";

const state = {
    notificationHistory: {
        data: [],
        meta: {
            current_page: 1,
            last_page: 1
        }
    }
};

const getters = {
    history: state => {
        return state.notificationHistory;
    }
};

const mutations = {
    notificationsListReceivedSuccess: (state, response) => {
        state.notificationHistory.data.push(...response.data);
        state.notificationHistory.meta = response.meta;
    },

    clearNotifications: state => {
        state.notificationHistory.data = [];
        state.notificationHistory.meta = {
            current_page: 1,
            last_page: 1
        };
    },
};

const actions = {
    loadNotifications({ commit }, page) {
        return new Promise((resolve, reject) => {
            getNotifications(page)
                .then((data) => {
                    commit("notificationsListReceivedSuccess", data);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    clearNotificationsData({ commit }) {
        commit("clearNotifications");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
